import React from 'react'
import { Link } from 'react-router-dom'
import { isAuthenticated, logout } from '../../services/self'
import SignIn from '../../components/SignIn'
import Register from '../../components/Register'
import logo from '../../Nlogo.png'
import PostmanLoginAuth from '../../images/postman_auth_projects.png'
import ChromeDevTool from '../../images/chromeDevTool.png'

import Download from '@axetroy/react-download'

export default class CaseStudies extends React.Component{


  logout() {
    logout()
    this.setState({ loggedOut: true })

  }


 idpCall() {
        var email = document.getElementById('email').value;
        fetch('https://api.newforma.cloud/v1/idp-configuration?email=' + email)
        .then(results => {
          return results.json();
        }).then(data =>{

          let clientId = data.providers[0].parameters[2].value;
          document.getElementById('pre').innerHTML = JSON.stringify(clientId, undefined, 2);
        })


 }



render() {
  return(
  <div>

      <div className="Logo">
        <Link className="home-link2" to='/'><img src={logo} className="App-logo" alt="logo" /></Link>
        <Link className="home-link" to='/'>Developer</Link>
      </div>

      <div className="Navbar-Div">
        <nav className="App-navbar">
        <Link className="Centered-link" to='/updates'>Updates</Link>
        <Link className="Centered-link" to='/getting-started'>Getting Started</Link>
        <Link className="Centered-link" to='/documentation'>Docs</Link>
        <Link className="Centered-link" to='/tools'>Tools</Link>
        <Link className="Centered-link" to='/community'>Community</Link>


        <div className="right">
          {isAuthenticated() ? (<Link to='/account'>Account</Link>) : ''}
          {isAuthenticated() ? (<Link to='' onClick={() => this.logout()}>Log out</Link>) : ''}
        </div>

            {isAuthenticated() ? '' : (
              <span className="right">
                <SignIn className="right" />
                <Register className="right-link" />
              </span>
            )}
        </nav>
      </div>

      <div className="App-banner">

        <span className="orange-bold">  NEWFORMA CONNECTED </span>

      </div>
      <div className="main-content-tools">
        <h1 className="introduction-header-lowercase" id="status">Dive into Newforma's APIs with Postman</h1>
        <p className="introduction-p-italic">
        Atomic batteries to power! Turbines to speed!
        </p>
        <hr className="short-hr"></hr>

        <p className="introduction-p-tools">
          Postman is a powerful third party tool that will help you gain a deeper understanding of Newforma's APIs without
          the necessity of writing any code. Postman will allow you to test all of our endpoints that are exposed in the API.
          Currently Postman is available within Chrome as a Chrome-App, it is also available for MacOS and Windows.
        </p>
        <h1 className='sub-introduction-header'>Setup Postman</h1>
        <p className="introduction-p-tools-inline">
          To install Postman simply visit the <a href="https://www.getpostman.com/apps"> Download Page </a> and choose your desired operating system.
        For easy setup use our Postman collection that already contains our /Projects and /ActionItems endpoints. Once downloaded simply
      click the "Import" button and choose Newforma's collection json file.</p>

          <Download className="introduction-p-tools" file="NewformaPostmanCollection.json" content='{
          	"id": "94929032-adbd-42fa-a136-00f7435ea16b",
          	"name": "Newforma Hybrid",
          	"description": "",
          	"auth": null,
          	"events": null,
          	"variables": [],
          	"order": [
          		"7cbd9c4e-fcd0-4d32-9b1c-ba40aeacae87",
          		"893e74f0-7616-41b2-a3b3-2ac13e58e8cb"
          	],
          	"folders_order": [],
          	"folders": [],
          	"requests": [
          		{
          			"id": "7cbd9c4e-fcd0-4d32-9b1c-ba40aeacae87",
          			"name": "/v1/Projects",
          			"url": "https://api.newforma.cloud/v1/projects",
          			"description": "Retrieve the list of \"My Projects\" for the authorizing user.",
          			"data": null,
          			"dataMode": "params",
          			"headerData": [
          				{
          					"key": "Content-Type",
          					"value": "application/json",
          					"description": "",
          					"enabled": true
          				}
          			],
          			"method": "GET",
          			"pathVariableData": [],
          			"queryParams": [],
          			"auth": {
          				"type": "awsv4",
          				"awsv4": [
          					{
          						"key": "accessKey",
          						"value": "ASIAXYJDUW5DUXDUEBM5",
          						"type": "string"
          					},
          					{
          						"key": "secretKey",
          						"value": "XT0+vMekbSdOF1GshiD5rVjA4RJZYenl7qOH+EsM",
          						"type": "string"
          					},
          					{
          						"key": "sessionToken",
          						"value": "FQoGZXIvYXdzEOT//////////wEaDLlg1esj9O5q6OCkZiL6BcR/+r3TOtVvlu/TTktiggWosNtdqvrU1zNwEvLQNkE/GRZrD/SUyF9h5JvDioc0/KTHPgO78PA8v9F0CWidnK/4h5WoAKwS7VkAKr0/shq3hpVFtVqqEmCFniS3MvyUKWnwxwJzJU9btn4mxuSobgY8sw5ctbbomczTuwluQGWK2NFbeG2AitA6wOODoAdUMbNjWOoZgQMVhHDif4lOYDIwM2j7hsV+Q1gO+QaA5PfRWdAtBYQCPgD3U2Bfwb+JmZj8ipEh4AGFxttpZcjBbr9dkZaEp5951yDm/rVjxMhv37Q+ETdNJHJ/nzTEd/uT6r17vwUTGxA009SELq0gpo4TyLb/ER6X8T5mgT7ent1pNZTiZWt/rXiOjgYooIYsw8XzjmCobpbk65eQfAHWmQaw4wJClBPQzGXxlOxQB49XH0XoGM0k5OuGrIY206xi4A2sMsfBatLsWRgby8dWBHIyal+AK0tiQfG49D3UNse9qsXvCfQgI0peTe+REaz+5ZdeiPiJaHKdfX6Z4+TKv9DBBq6KaMS2Lpk8TYkmLbMcuAlGsSaqStVGaOsFsjgnYLmf1dc92Qimhv+iJDHa+p4fkbfDGtfOh5nkzA0pwUVYH6y0LZuv2X+XrnnP2Yy//8uIAuKMnRl4OaJ8jQR6/gq8YdiR3WLEHlirROKXRCChtGBKfe0BNSlXeNFwefwz4Lw0sL7ltr6C+BkilaCfQGfWSn7PFWmdnGsqn0biiby3jHU0a2qjLoLxoo3AH/oefCiWjwa329jSauJAhq8kWyOxg4fA0n038Mi+aZm8Uea/9vosoZsRiAjeiJiv0wbuwCnFUSnwVURAZjjD3pTPz659Q3T4L9Dwpg9EfDpQfuGWqHfBqsZLqqGpuDf1S6dg1jNQE9twD6gdA/CJ6ykSwY+mym7ppOvCLstPXV3NH1gvmVdwZZSZDD9LpPnIN6F8z/EWzlLPAqBv2v9rtkcXBWnszTM8oEoifIGEX7q7rCIjO3ne39+bLshz4CjfhrLbBQ==",
          						"type": "string"
          					},
          					{
          						"key": "region",
          						"value": "us-east-1",
          						"type": "string"
          					},
          					{
          						"key": "service",
          						"value": "execute-api",
          						"type": "string"
          					},
          					{
          						"key": "saveToRequest",
          						"value": true,
          						"type": "boolean"
          					}
          				]
          			},
          			"events": [],
          			"folder": null,
          			"headers": "Content-Type: application/json\n",
          			"pathVariables": {}
          		},
          		{
          			"id": "893e74f0-7616-41b2-a3b3-2ac13e58e8cb",
          			"name": "/v1/actionitems",
          			"url": "https://api.newforma.cloud/v1/actionitems",
          			"description": "Retrieve actions created by and or assigned to the authorizing user.",
          			"data": null,
          			"dataMode": "params",
          			"headerData": [
          				{
          					"key": "Content-Type",
          					"value": "application/json",
          					"description": "",
          					"enabled": true
          				}
          			],
          			"method": "GET",
          			"pathVariableData": [],
          			"queryParams": [],
          			"auth": {
          				"type": "awsv4",
          				"awsv4": [
          					{
          						"key": "accessKey",
          						"value": "ASIAXYJDUW5DUXDUEBM5",
          						"type": "string"
          					},
          					{
          						"key": "secretKey",
          						"value": "XT0+vMekbSdOF1GshiD5rVjA4RJZYenl7qOH+EsM",
          						"type": "string"
          					},
          					{
          						"key": "sessionToken",
          						"value": "FQoGZXIvYXdzEOT//////////wEaDLlg1esj9O5q6OCkZiL6BcR/+r3TOtVvlu/TTktiggWosNtdqvrU1zNwEvLQNkE/GRZrD/SUyF9h5JvDioc0/KTHPgO78PA8v9F0CWidnK/4h5WoAKwS7VkAKr0/shq3hpVFtVqqEmCFniS3MvyUKWnwxwJzJU9btn4mxuSobgY8sw5ctbbomczTuwluQGWK2NFbeG2AitA6wOODoAdUMbNjWOoZgQMVhHDif4lOYDIwM2j7hsV+Q1gO+QaA5PfRWdAtBYQCPgD3U2Bfwb+JmZj8ipEh4AGFxttpZcjBbr9dkZaEp5951yDm/rVjxMhv37Q+ETdNJHJ/nzTEd/uT6r17vwUTGxA009SELq0gpo4TyLb/ER6X8T5mgT7ent1pNZTiZWt/rXiOjgYooIYsw8XzjmCobpbk65eQfAHWmQaw4wJClBPQzGXxlOxQB49XH0XoGM0k5OuGrIY206xi4A2sMsfBatLsWRgby8dWBHIyal+AK0tiQfG49D3UNse9qsXvCfQgI0peTe+REaz+5ZdeiPiJaHKdfX6Z4+TKv9DBBq6KaMS2Lpk8TYkmLbMcuAlGsSaqStVGaOsFsjgnYLmf1dc92Qimhv+iJDHa+p4fkbfDGtfOh5nkzA0pwUVYH6y0LZuv2X+XrnnP2Yy//8uIAuKMnRl4OaJ8jQR6/gq8YdiR3WLEHlirROKXRCChtGBKfe0BNSlXeNFwefwz4Lw0sL7ltr6C+BkilaCfQGfWSn7PFWmdnGsqn0biiby3jHU0a2qjLoLxoo3AH/oefCiWjwa329jSauJAhq8kWyOxg4fA0n038Mi+aZm8Uea/9vosoZsRiAjeiJiv0wbuwCnFUSnwVURAZjjD3pTPz659Q3T4L9Dwpg9EfDpQfuGWqHfBqsZLqqGpuDf1S6dg1jNQE9twD6gdA/CJ6ykSwY+mym7ppOvCLstPXV3NH1gvmVdwZZSZDD9LpPnIN6F8z/EWzlLPAqBv2v9rtkcXBWnszTM8oEoifIGEX7q7rCIjO3ne39+bLshz4CjfhrLbBQ==",
          						"type": "string"
          					},
          					{
          						"key": "region",
          						"value": "us-east-1",
          						"type": "string"
          					},
          					{
          						"key": "service",
          						"value": "execute-api",
          						"type": "string"
          					},
          					{
          						"key": "saveToRequest",
          						"value": true,
          						"type": "boolean"
          					}
          				]
          			},
          			"events": [],
          			"folder": null,
          			"headers": "Content-Type: application/json\n",
          			"pathVariables": {}
          		}
          	]
          }'>
        <button className="create-btn-postman" type="button">


          Postman collection</button></Download>.



        <p className="introduction-p-tools">
          To import the Newforma Postman Collection choose "File -> Import -> Select Import File -> Either drag and drop Collection file or browse to it with Choose Files Button."
          Open the collection from the list of Collections on the left of the screen. For example choose the /v1/Projects, you are now ready to collect three values from
          Chrome to make your API request.
        </p>
        <img className="tools-img" alt="postman" src={PostmanLoginAuth}></img>

        <h1 className='sub-introduction-header'>Chrome Developer Tools</h1>
        <p className="introduction-p-tools">
          We will use Chrome Developer Tools to grab the required values for the AWS Signature v4.0 parameters. Open Chrome and browse to <a href="https://newforma.cloud">
          https://newforma.cloud</a>. In Windows use the shortcut Ctrl + Shift + i and Mac use Command + Option + i to open the Developer Tools. Now log in to Newforma Cloud
          with the user you want to use in Postman. Once log in is complete find the Console tab within the Developer Tools. Type the following commands,
          <span className='italic'>localStorage["accessKeyId"]</span>, <span className='italic'>localStorage["secretAccessKey"]</span> and
          <span className='italic'>localStorage["sessionToken"]</span>. Each of these will fetch the value and display it in red text. Copy each of these into the Authorization
          tab in Postman, secretAccessKey is to be pasted in the secretKey text box. You should now be able to click the blue "Send" button in Postman and view the response.
          <br />
          ***Important Note: Do not copy the surround quotation marks into Postman, only grab the text between.***


        </p>
        <img className="tools-img" alt="chrome" src={ChromeDevTool}></img>

        <h1 className="introduction-header-lowercase" id="idTool">Client ID Tool</h1>
        <hr className="short-hr"></hr>
        <p className="introduction-p-tools">
          Use the form below to submit the user email you are using with the Authentication Sample Code to retrieve the correct "clientId" for you
          Azure AD Enterprise App.
        </p>
        <div className="idpTool">
          <p className="idpTextLabel">Enter Email Address: </p>
          <div className="idpTextInput"><input style={{width: '30%', marginLeft: '20px'}} id='email' type='text' placeholder="Email Address"/></div>
          <button className="idpButton" onClick={this.idpCall}>Get Azure Client ID</button>
        <br />
        <br />
          <p className="idpTextLabel">Client ID: </p>
          <pre className="preStyle" id='pre'>"101a0e-3x4a-4m3p-9l7e-2i5d5589e367"</pre>
        </div>
      </div>

    </div> )
  }
}



/** WEBPACK FOOTER **
 ** ./src/pages/Tools/index.js
 **/